module.exports = __webpack_public_path__ + "static/media/arrow-right.21ee6034.svg";